export const GEO_TOTAL_GET = '[GEO] TOTAL GET';
export const GEO_TOTAL_SUCCESS = '[GEO] TOTAL SUCCESS';
export const GEO_TOTAL_FAILED = '[GEO] TOTAL FAILED';
export const GEO_PARAM_GET  = '[GEO] PARAM GET';
export const GEO_PARAM_SUCCESS  = '[GEO] PARAM SUCCESS';
export const GEO_PARAM_UPDATE  = '[GEO] PARAM UPDATE';
export const GEO_REGION_GET = '[GEO] REGION GET';
export const GEO_REGION_SUCCESS = '[GEO] REGION SUCCESS';
